export default __webpack_public_path__ + "static/media/carrinho_01.b0bcffc4.png";